import React,{Fragment} from 'react';
import {useParams} from 'react-router-dom'
import Loader from '../loading/loading.component';
import DisplayList from '../list-container/display-list.component';
import { ArtistCoverContainer, ArtistCoverImageContainer, TextContainer } from './artist-cover.styles.js';
import FetchTracksData from '../../custom-hooks/fetch-tracks-data';

function ArtistTracks(){
    let params = useParams();
    const {loading, tracks} = FetchTracksData(`https://ws.audioscrobbler.com/2.0/?method=artist.gettoptracks&artist=${params.artist.replace('&+','')}&api_key=627d96b414f95a9921f55e6a4b130cb3&format=json`,params);

    let img = tracks[0];
    let link = '';
    if(img!==undefined)
        link = img.image;
    return (
        <div>
            {
                loading===undefined || loading?<Loader/>
                :
                <Fragment>
                    <ArtistCoverContainer>
                        <ArtistCoverImageContainer alt ="cover" src = {link}/>
                        <TextContainer>{params.artist.replace(/\+/g, ' ')}</TextContainer>
                    </ArtistCoverContainer>
                    <DisplayList tracks={tracks}/>
                </Fragment>
            }
        </div>
    )
}

export default ArtistTracks;






// import React, {useEffect, useState, Fragment} from 'react';
// import {useParams} from 'react-router-dom'
// import Loader from '../loading/loading.component';
// import DisplayList from '../list-container/display-list.component';
// import { ArtistCoverContainer, ArtistCoverImageContainer, TextContainer } from './artist-cover.styles.js';
// function ArtistTracks(){
//     let params = useParams();
//     const [tracks, setTracks] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect( ()=> {
        
//         async function fetchTracks(){
//             let result =  await fetch(`http://ws.audioscrobbler.com/2.0/?method=artist.gettoptracks&artist=${params.artist}&api_key=627d96b414f95a9921f55e6a4b130cb3&format=json`,
//                 {
//                     method: 'GET',                 
//                 }
//             )
//             .then(res => res.json()).then(res=>res.toptracks.track);
//             let promises = result.map(track=>{
//                 return fetch(`https://api.genius.com/search?q=${track.name}&access_token=W9YRsCxZ1uJvh97K48L-EfCt50u6H_74Ywuz2oNUg8hwOhTeW8jrvcTOxwNzU0UJ`,
//                     {
//                         method:'GET',
//                     }
//                 )
//                 .then(res=>res.json());
//             });
//             let artistInfo = await Promise.all(promises);
//             let artistDetails = [];
//             artistInfo.forEach( (artist) =>{
//                 let obj = {};
//                 let response = artist.response.hits;
//                 let len = response.length;
//                 for(let i=0;i<len;i++){
//                     if(response[i].result.primary_artist.name.toLowerCase()===params.artist.replace(/\+/g,' ').toLowerCase()){
//                         obj["id"] = response[i].result.id;
//                         // eslint-disable-next-line                         
//                         obj["title"] = response[i].result.title.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
//                         obj["artist"] = params.artist.replace(/\+/g,' ');
//                         obj["image"] = response[i].result.song_art_image_thumbnail_url;
//                         artistDetails.push(obj);
//                         break;
//                     }
//                 }
//             });
//             setTracks(artistDetails);
//             setLoading(false);
//         }
//         fetchTracks();
//         // eslint-disable-next-line react-hooks/exhaustive-deps        
//     }, [])
//     let img = tracks[0];
//     let link = '';
//     if(img!==undefined)
//         link = img.image;
//     return (
//         <div>
//             {
//                 loading===undefined || loading?<Loader/>
//                 :
//                 <Fragment>
//                     <ArtistCoverContainer>
//                         <ArtistCoverImageContainer alt ="cover" src = {link}/>
//                         <TextContainer>{params.artist.replace(/\+/g, ' ')}</TextContainer>
//                     </ArtistCoverContainer>
//                     <DisplayList tracks={tracks}/>
//                 </Fragment>
//             }
//         </div>
//     )
// }

// export default ArtistTracks;


// import React, {useEffect, useState, Fragment} from 'react';
// import {useParams} from 'react-router-dom'
// import Loader from '../loading/loading.component';
// import DisplayList from '../list-container/display-list.component';
// function ArtistTracks(){
//     let params = useParams();
//     console.log(params);
//     const [tracks, setTracks] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect( ()=> {
        
//         async function fetchTracks(){
//             let results =  await fetch(`https://api.genius.com/artists/${params.id}/songs?&access_token=W9YRsCxZ1uJvh97K48L-EfCt50u6H_74Ywuz2oNUg8hwOhTeW8jrvcTOxwNzU0UJ&limit=1000`,
//                 {
//                     method: 'GET',                 
//                 }
//             )
//             .then(res => res.json());
//             let arr = [];
//             results.response.songs.forEach((track,index)=>{
//                 if(track.primary_artist.name.toLowerCase()===params.artist.replace(/\+/g,' ').toLowerCase()){
//                     let obj = {};                
//                     obj["id"] = track.id;
//                     obj["image"] = track.song_art_image_thumbnail_url;
//                     // eslint-disable-next-line
//                     obj["title"] = track.title.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
//                     obj["artist"] = params.artist.replace(/\+/g,' ');
//                     arr.push(obj);
//                 }
//             });
//             setLoading(false);
//             setTracks(arr);
//         }
//         fetchTracks();
//         // eslint-disable-next-line react-hooks/exhaustive-deps        
//     }, [])
//     let img = tracks[0];
//     let link = '';
//     console.log(img);
//     if(img!==undefined)
//         link = img.image;
//     return (
//         <div>
//             {
//                 loading===undefined || loading?<Loader/>
//                 :
//                 <Fragment>
//                     <div style={{"background-color":"black", width:"100vw", heigth:"300px"}}>
//                         <img alt ="cover" src = {link} style={{"width":"20vw","height":"300px"}}/>
//                     </div>
//                     <DisplayList tracks={tracks}/>
//                 </Fragment>
//             }
//         </div>
//     )
// }

// export default ArtistTracks;